/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ResponseContent,
  ResponseContent$inboundSchema,
  ResponseContent$Outbound,
  ResponseContent$outboundSchema,
} from "./responsecontent.js";

export type ResponseOutputMessage = {
  type?: "message" | undefined;
  id: string;
  role?: "assistant" | undefined;
  content: Array<ResponseContent>;
};

/** @internal */
export const ResponseOutputMessage$inboundSchema: z.ZodType<
  ResponseOutputMessage,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("message").default("message"),
  id: z.string(),
  role: z.literal("assistant").default("assistant"),
  content: z.array(ResponseContent$inboundSchema),
});
/** @internal */
export type ResponseOutputMessage$Outbound = {
  type: "message";
  id: string;
  role: "assistant";
  content: Array<ResponseContent$Outbound>;
};

/** @internal */
export const ResponseOutputMessage$outboundSchema: z.ZodType<
  ResponseOutputMessage$Outbound,
  z.ZodTypeDef,
  ResponseOutputMessage
> = z.object({
  type: z.literal("message").default("message" as const),
  id: z.string(),
  role: z.literal("assistant").default("assistant" as const),
  content: z.array(ResponseContent$outboundSchema),
});

export function responseOutputMessageToJSON(
  responseOutputMessage: ResponseOutputMessage,
): string {
  return JSON.stringify(
    ResponseOutputMessage$outboundSchema.parse(responseOutputMessage),
  );
}
export function responseOutputMessageFromJSON(
  jsonString: string,
): SafeParseResult<ResponseOutputMessage, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ResponseOutputMessage$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResponseOutputMessage' from JSON`,
  );
}
